import classNames from 'classnames';
import Collapsible from 'components/Collapsible/Collapsible';
import Icon from 'components/Icon/Icon';
import type { FC } from 'react';
import { Translation } from 'utils/translations';

import styles from './styles.module.scss';

const SelfRegulationSection: FC = () => {
  return (
    <Collapsible className={styles.control}>
      <Collapsible.Trigger>
        {({ expanded }) => (
          <div className={styles['control-header']}>
            <Icon
              name="clipboard-close.bold"
              width={48}
              height={48}
              className={styles.icon}
            />
            <div className={styles['control-header-content']}>
              <div className={styles.title}>
                <Translation message="deposit_limits" />
              </div>
              <p className={styles.description}>
                <Translation message="self_regulation_deposit_limits" />
              </p>
            </div>
            <Icon
              name="arrow-right.circle"
              className={classNames(styles.arrow, {
                [styles['arrow-expanded']]: expanded,
              })}
            />
          </div>
        )}
      </Collapsible.Trigger>
      <Collapsible.Content>
        <div>Self regulation content</div>
      </Collapsible.Content>
    </Collapsible>
  );
};

export default SelfRegulationSection;
